import { Component, OnInit } from '@angular/core';
import {galleryImages} from '../webData';


@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css']
})
export class GalleryComponent implements OnInit {
  images: any;

  constructor() {
    this.images = galleryImages;

   }

  ngOnInit() {
    this.images = galleryImages;
    console.log(this.images);
  }

}



// WEBPACK FOOTER //
// /Users/samirjha/Project/nushing/src/app/gallery/gallery.component.ts